<users [resourceType]="resourceType"></users>

